export class NotificationSaleAdminModel {
  notificationTypeId: number;
  isEmail: boolean;
  isSMS: boolean;
  emailBody: string;
  smsMessage: string;
  emailSubject: string;
}

export class NotificationSaleAdmin {
  id: number;
  emailTemplateId: number;
  smsTemplateId: number;
  notificationTypeId: number;
  isEmail: boolean;
  isSMS: boolean;
  isPush: boolean;
  emailSubject: string;
  emailBody: string;
  smsMessage: string;
  createdBy: number;
  createdDate: string;
}

export enum NotificationSaleAdminTabs {
  LIST = 'list',
  ADD = 'add'
}
